import { render } from "./ListDataPhApprove.vue?vue&type=template&id=556a0503"
import script from "./ListDataPhApprove.vue?vue&type=script&lang=js"
export * from "./ListDataPhApprove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__